var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCallCenter = function SvgCallCenter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "2 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.562v-1.458h5.875v-.916h-3.167V9.875h3.167v-1c0-1.639-.57-3.028-1.708-4.167C13.027 3.569 11.639 3 10 3c-1.639 0-3.028.57-4.167 1.708-1.139 1.14-1.708 2.528-1.708 4.167v1h3.167v6.313H2.667V8.854c0-1 .191-1.948.573-2.844a7.316 7.316 0 0 1 1.562-2.333 7.338 7.338 0 0 1 2.333-1.562A7.228 7.228 0 0 1 10 1.542c1.014 0 1.969.191 2.865.573a7.338 7.338 0 0 1 2.333 1.562c.66.66 1.18 1.438 1.562 2.333.382.896.573 1.851.573 2.865v9.687H10Zm-5.875-3.833h1.708v-3.396H4.125v3.396Zm10.042 0h1.708v-3.396h-1.708v3.396Z",
    fill: "#000"
  })));
};
export default SvgCallCenter;